import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Realmente van a comer estas recetas?',
  answer: 'Sí. Están pensadas para que sepan igual (o mejor) que sus comidas favoritas. Los chicos piden repetir.',
  accent: 'border-l-orange-500',
  chevron: 'text-orange-500',
  answerColor: 'text-orange-700'
}, {
  question: '¿Necesito ingredientes especiales?',
  answer: 'Para nada. Todo con ingredientes de supermercado común. Nada raro ni caro.',
  accent: 'border-l-violet-500',
  chevron: 'text-violet-500',
  answerColor: 'text-violet-700'
}, {
  question: '¿Funcionan para niños muy selectivos?',
  answer: 'Sí, están diseñadas para los niños más rebeldes! Incluso con Trastornos del Espectro Autista.',
  accent: 'border-l-emerald-500',
  chevron: 'text-emerald-500',
  answerColor: 'text-emerald-700'
}, {
  question: '¿Cómo accedo al recetario?',
  answer: 'Inmediatamente después de comprar, recibirás en tu e-mail el recetario para ver el libro digital desde tu celular o computadora.',
  accent: 'border-l-orange-400',
  chevron: 'text-orange-400',
  answerColor: 'text-orange-700'
}, {
  question: '¿Cuánto tardan en enviarme el recetario?',
  answer: 'Es inmediato. Apenas comprás se te envía el recetario a tu correo electrónico.',
  accent: 'border-l-violet-400',
  chevron: 'text-violet-400',
  answerColor: 'text-violet-700'
}];
function FAQItem({
  question,
  answer,
  accent,
  chevron,
  answerColor
}: {
  question: string;
  answer: string;
  accent: string;
  chevron: string;
  answerColor: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className={`bg-white rounded-2xl shadow-sm border-l-4 ${accent} overflow-hidden`} data-id="element-52">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-6 py-5 text-left gap-4" data-id="element-53">
        <span className="font-bold text-gray-900 text-base leading-snug" data-id="element-54">
          {question}
        </span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className={`flex-shrink-0 ${chevron}`} data-id="element-55">
          <ChevronDown className="w-5 h-5" data-id="element-56" />
        </motion.span>
      </button>

      <AnimatePresence initial={false} data-id="element-57">
        {open && <motion.div key="answer" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.28,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-58">
            <p className={`px-6 pb-5 text-sm leading-relaxed border-t border-gray-100 pt-3 font-medium ${answerColor}`} data-id="element-59">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <section className="py-16 bg-[#FEE9D0]" data-id="element-60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-2xl" data-id="element-61">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-extrabold text-center mb-10" data-id="element-62">
          <span className="bg-gradient-to-r from-orange-500 via-violet-600 to-emerald-500 bg-clip-text text-transparent" data-id="element-63">
            ¿TENÉS DUDAS?
          </span>{' '}
          <span className="text-gray-900 font-normal" data-id="element-64">Tenemos respuestas:</span>
        </motion.h2>

        <div className="flex flex-col gap-3" data-id="element-65">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} data-id="element-66">
              <FAQItem question={faq.question} answer={faq.answer} accent={faq.accent} chevron={faq.chevron} answerColor={faq.answerColor} data-id="element-67" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}